import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_IDS_SUCCESS,
  DELETE_IDS_SUCCESS,
  GET_IDS_FAIL,
  GET_IDS_SUCCESS,
  UPDATE_IDS_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  ids: [],
  exports: [],
  defective: [],
  error: {},
};

const IDS = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_IDS_SUCCESS:
      return {
        ...state,
        ids: action.payload.apples,
        exports: action.payload.exports,
        defective: action.payload.defective,
      };

    case GET_IDS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_IDS_SUCCESS:
      return {
        ...state,
        ids: [...state.ids, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_IDS_SUCCESS:
      return {
        ...state,
        ids: state.ids.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_IDS_SUCCESS:
      return {
        ...state,
        ids: state.ids.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default IDS;
